import { useContext, useEffect } from "react";
import HowItWorksSplit from "../components/HowItWorksSplit";
import ParticipatingRestaurants from "../components/ParticipatingRestaurants";
import SelectShowPosterStrip from "../components/SelectShowPosterStrip";
import SlidingHeader from "../components/headers/SlidingHeader";
import GlobalContext from "../contexts/store";
import banner from "../assets/images/dinner-and-show.jpg";
import menu from "../assets/images/dinner-and-show-menu.jpg";
import restaurantImg1 from "../assets/images/alder-and-birch.png";
import restaurantImg2 from "../assets/images/bailiwick.jpg";
import restaurantImg3 from "../assets/images/big-als.jpg";
import restaurantLogo1 from "../assets/images/alder-logo.png";
import restaurantLogo2 from "../assets/images/bailiwick-logo.png";
import restaurantLogo3 from "../assets/images/big-als-logo.png";

export default function DinnerAndShow() {
  const { upcomingEvents } = useContext(GlobalContext);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const showPosterItems = (upcomingEvents || [])
    .filter((event) => event?.promo?.story && event?.slug)
    .map((event) => ({
      key: event._id,
      image: event.promo.story,
      to: `/events/event/${event.slug}`,
      alt: event?.organization?.name || "Show",
    }));

    // const showPosterItems = Array.from({ length: 10 }, (_, i) => (upcomingEvents || []).filter((e) => e?.promo?.story && e?.slug).map((e) => ({ key: `${e._id}-${i}`, image: e.promo.story, to: `/events/event/${e.slug}`, alt: e?.organization?.name || "Show" }))).flat();


  return (
    <>
      <div className="mt-20">
        <img src={banner} alt="dinner and a show banner" className="mx-auto w-full h-[300px] md:h-[500px] xl:h-[600px] object-cover" />
      </div>

      <HowItWorksSplit
        side="left"
        banner={
          <div className="flex w-full justify-center px-3 lg:px-0">
            <div className="aspect-[3/4] w-full max-w-[420px] min-w-0">
              <img
                src={menu}
                alt="Dinner & A Show at The Orleans"
                className="block h-full w-full object-cover object-center"
              />
            </div>
          </div>
        }
        numberedList={[
          "Select the show you want to attend",
          "Add RSVP Dinner Package at checkout",
          "Enjoy exclusive discounted dinner packages before OR after the show",
          "Dinner price is not included in the ticket price of the show",
        ]}
      />

      <SelectShowPosterStrip items={showPosterItems} />

      <ParticipatingRestaurants
        items={[
          {
            id: "baliwick",
            imageSrc: restaurantImg2,
            imageAlt: "Baliwick restaurant",
            title: "Baliwick - All American Pub + Eatery",
            description:
              "Baliwick brings a lively, social energy to classic American dining with a modern twist. Featuring a menu filled with elevated comfort food favorites, signature burgers, and a wide selection of beers and cocktails, it's designed for guests who want great food in a fun, relaxed environment. With its open layout and entertainment-driven atmosphere, Baliwick is ideal for groups, casual date nights, or anyone looking to keep the energy going before or after the show.",
            logo: (
              <img src={restaurantLogo2} alt="Baliwick logo" className="w-[222px] h-[40px]" />
            ),
          },
          {
            id: "alder-birch",
            imageSrc: restaurantImg1,
            imageAlt: "Alder & Birch dining room",
            title: "Alder & Birch - Cocktails Dining",
            description:
              "Alder & Birch delivers a refined yet welcoming dining experience centered around elevated American cuisine. Known for its premium steaks, expertly crafted cocktails, and warm, modern ambiance, it's the perfect choice for guests looking to start or end their evening with something upscale. Whether you're enjoying a perfectly cooked filet or a handcrafted drink at the bar, Alder & Birch sets the tone for a memorable night out with a balance of sophistication and comfort.",
            logo: (
                <img src={restaurantLogo1} alt="Baliwick logo" className="w-[235px] h-[80px]" />
            ),
          },
          {
            id: "big-als",
            imageSrc: restaurantImg3,
            imageAlt: "Big Al's Oyster Bar",
            title: "Big Al's Oyster Bar",
            description:
              "Big Al's Oyster Bar offers a bold, flavor-packed experience inspired by the rich culinary traditions of New Orleans. Specializing in fresh seafood, hearty gumbo, and signature Cajun and Creole dishes, this spot delivers authentic flavors in a vibrant, welcoming setting. From oysters on the half shell to classic seafood boils, Big Al's is perfect for guests craving something indulgent and full of character to complement their night of entertainment.",
            logo: (
                <img src={restaurantLogo3} alt="Baliwick logo" className="w-[208px] h-[70px]" />
            ),
          },
        ]}
      />

      <SlidingHeader showOverlay={false} images={[]} />
    </>
  );
}